import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { theme } from "../../utils/theme";

interface LoaderProps {
  showLoader: boolean;
}

export const Loader = (props: LoaderProps) => {
  return (
    <Backdrop
      sx={{
        color: theme.palette.common.white,
        zIndex: (theme) => theme.zIndex.drawer + 200,
      }}
      open={props.showLoader}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
